<template>
  <div class="panel">
    <div v-if="$slots.header" class="panel-header">
      <slot name="header" />
    </div>
    <slot />
  </div>
</template>

<style scoped>
.panel {
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}
</style>
